import React, { Component } from 'react'
import Input from './Input'
import Icon from './Icon'

class NumberInput extends Component {
  render() {
    const { props } = this

    return (
      <div
        className={`ui gp-number-input ${props.className} ${
          props.dark ? ' dark' : ''
        }`}
        style={{ ...props.style }}
      >
        <span className='control minus' onClick={props.decrease}>
          <Icon name='minus' />
        </span>
        <Input type='number' value={props.value} events={props.events} />
        <span className='control plus' onClick={props.increase}>
          <Icon name='plus' />
        </span>
      </div>
    )
  }
}

NumberInput.defaultProps = {
  style: {},
  className: ''
}

export default NumberInput
